export default __webpack_public_path__ + "static/media/papago.fa78c494.jpg";